import type { DominantEmotion, PlanAdherence } from 'shared';

import { Input } from '../../components/ui/Input';

import { emotionOptions, planAdherenceOptions } from './reviewOptions';

export function PlanAdherenceSelect({
  value,
  onChange,
}: {
  value: PlanAdherence | '';
  onChange: (value: PlanAdherence) => void;
}) {
  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium">Plan adherence</legend>
      <div className="grid gap-2 sm:grid-cols-3">
        {planAdherenceOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={value === option.value}
            className={`min-h-11 rounded border px-3 py-2 text-left text-sm ${
              value === option.value
                ? 'border-accent bg-accent/10 text-accent'
                : 'border-border bg-bg text-text'
            }`}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </fieldset>
  );
}

export function EmotionSelect({
  value,
  onChange,
}: {
  value: DominantEmotion | '';
  onChange: (value: DominantEmotion) => void;
}) {
  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium">Dominant emotion</legend>
      <div className="flex flex-wrap gap-2">
        {emotionOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={value === option.value}
            className={`min-h-11 rounded-full border px-4 py-2 text-sm ${
              value === option.value
                ? 'border-accent bg-accent/10 text-accent'
                : 'border-border bg-bg text-text'
            }`}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </fieldset>
  );
}

export function LessonInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <label className="block text-sm font-medium" htmlFor="one-line-lesson">
      One-line lesson
      <Input
        id="one-line-lesson"
        className="mt-1"
        maxLength={140}
        placeholder="One thing you'd do differently (optional)"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  );
}
